import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import LabContent from './LabContent';
import Footer from './Footer';
import './css/Lab.css';

const Lab = ({ isCollapsed, toggleSidebar }) => {
  return (
    <div className='lab-container'>
      <Navbar />
      <LabContent />
      <Footer />
    </div>
  );
};

export default Lab;
